import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fin-skip-link',
  templateUrl: './skip-link.component.html',
  styleUrls: ['./skip-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SkipLinkComponent {
  @Input() main: HTMLElement;

  skipToMainContent(): void {
    this.main.setAttribute('tabindex', '-1');
    this.main.focus();
  }
}
